/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Origin } from './Origin';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
    OriginToJSONTyped,
} from './Origin';
import type { IdNameResultOfint } from './IdNameResultOfint';
import {
    IdNameResultOfintFromJSON,
    IdNameResultOfintFromJSONTyped,
    IdNameResultOfintToJSON,
    IdNameResultOfintToJSONTyped,
} from './IdNameResultOfint';
import type { PaymentStatus } from './PaymentStatus';
import {
    PaymentStatusFromJSON,
    PaymentStatusFromJSONTyped,
    PaymentStatusToJSON,
    PaymentStatusToJSONTyped,
} from './PaymentStatus';

/**
 * 
 * @export
 * @interface GetPaymentResponse
 */
export interface GetPaymentResponse {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentResponse
     */
    currency: string;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentResponse
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentResponse
     */
    surchargeAmount: number;
    /**
     * 
     * @type {number}
     * @memberof GetPaymentResponse
     */
    totalAmount: number;
    /**
     * 
     * @type {Date}
     * @memberof GetPaymentResponse
     */
    transactionDate: Date;
    /**
     * 
     * @type {PaymentStatus}
     * @memberof GetPaymentResponse
     */
    status: PaymentStatus;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentResponse
     */
    settled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPaymentResponse
     */
    approved: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentResponse
     */
    failureReason: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentResponse
     */
    externalStatus: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentResponse
     */
    externalTransactionId: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentResponse
     */
    externalPayload: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentResponse
     */
    referenceTransactionId: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentResponse
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentResponse
     */
    invoiceNo: string | null;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof GetPaymentResponse
     */
    student: IdNameResultOfint | null;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof GetPaymentResponse
     */
    location: IdNameResultOfint | null;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof GetPaymentResponse
     */
    user: IdNameResultOfint | null;
    /**
     * 
     * @type {Date}
     * @memberof GetPaymentResponse
     */
    paymentDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentResponse
     */
    paymentTime: string;
    /**
     * 
     * @type {Date}
     * @memberof GetPaymentResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {Origin}
     * @memberof GetPaymentResponse
     */
    origin: Origin;
}



/**
 * Check if a given object implements the GetPaymentResponse interface.
 */
export function instanceOfGetPaymentResponse(value: object): value is GetPaymentResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('surchargeAmount' in value) || value['surchargeAmount'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('transactionDate' in value) || value['transactionDate'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('settled' in value) || value['settled'] === undefined) return false;
    if (!('approved' in value) || value['approved'] === undefined) return false;
    if (!('failureReason' in value) || value['failureReason'] === undefined) return false;
    if (!('externalStatus' in value) || value['externalStatus'] === undefined) return false;
    if (!('externalTransactionId' in value) || value['externalTransactionId'] === undefined) return false;
    if (!('externalPayload' in value) || value['externalPayload'] === undefined) return false;
    if (!('referenceTransactionId' in value) || value['referenceTransactionId'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('invoiceNo' in value) || value['invoiceNo'] === undefined) return false;
    if (!('student' in value) || value['student'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('paymentDate' in value) || value['paymentDate'] === undefined) return false;
    if (!('paymentTime' in value) || value['paymentTime'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function GetPaymentResponseFromJSON(json: any): GetPaymentResponse {
    return GetPaymentResponseFromJSONTyped(json, false);
}

export function GetPaymentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPaymentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'currency': json['currency'],
        'amount': json['amount'],
        'surchargeAmount': json['surchargeAmount'],
        'totalAmount': json['totalAmount'],
        'transactionDate': (new Date(json['transactionDate'])),
        'status': PaymentStatusFromJSON(json['status']),
        'settled': json['settled'],
        'approved': json['approved'],
        'failureReason': json['failureReason'],
        'externalStatus': json['externalStatus'],
        'externalTransactionId': json['externalTransactionId'],
        'externalPayload': json['externalPayload'],
        'referenceTransactionId': json['referenceTransactionId'],
        'description': json['description'],
        'invoiceNo': json['invoiceNo'],
        'student': IdNameResultOfintFromJSON(json['student']),
        'location': IdNameResultOfintFromJSON(json['location']),
        'user': IdNameResultOfintFromJSON(json['user']),
        'paymentDate': (new Date(json['paymentDate'])),
        'paymentTime': json['paymentTime'],
        'createdAt': (new Date(json['createdAt'])),
        'origin': OriginFromJSON(json['origin']),
    };
}

export function GetPaymentResponseToJSON(json: any): GetPaymentResponse {
    return GetPaymentResponseToJSONTyped(json, false);
}

export function GetPaymentResponseToJSONTyped(value?: GetPaymentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'currency': value['currency'],
        'amount': value['amount'],
        'surchargeAmount': value['surchargeAmount'],
        'totalAmount': value['totalAmount'],
        'transactionDate': value['transactionDate'].toISOString().substring(0,10),
        'status': PaymentStatusToJSON(value['status']),
        'settled': value['settled'],
        'approved': value['approved'],
        'failureReason': value['failureReason'],
        'externalStatus': value['externalStatus'],
        'externalTransactionId': value['externalTransactionId'],
        'externalPayload': value['externalPayload'],
        'referenceTransactionId': value['referenceTransactionId'],
        'description': value['description'],
        'invoiceNo': value['invoiceNo'],
        'student': IdNameResultOfintToJSON(value['student']),
        'location': IdNameResultOfintToJSON(value['location']),
        'user': IdNameResultOfintToJSON(value['user']),
        'paymentDate': value['paymentDate'].toISOString().substring(0,10),
        'paymentTime': value['paymentTime'],
        'createdAt': value['createdAt'].toISOString(),
        'origin': OriginToJSON(value['origin']),
    };
}

